import React from "react";
import SuperAdminLoginComponent from "../components/auth/SuperAdminLoginComponent";

const SuperAdminLoginPage = () => {
  return (
    <>
      <SuperAdminLoginComponent />
    </>
  );
};

export default SuperAdminLoginPage;
